<template>
    <div class="float-left mr-1">
        <span class="text-warning">
            <i
                class="fa fa-minus-circle fa-lg icon-button"
                title="Atualizar Desconto"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">Desconto no item da requisição</div>
            <b-row v-if="itemRequisicao">
                <b-col sm="12">
                    <detalhe titulo="Código" :size="size1">{{
                        itemRequisicao.idItemContrato
                    }}</detalhe>
                    <detalhe titulo="Item do Contrato" :size="size1">{{
                        itemRequisicao.descricao
                    }}</detalhe>
                    <detalhe titulo="Valor Unitário" :size="size1">{{
                        itemRequisicao.valorUnitario | currency
                    }}</detalhe>
                    <detalhe titulo="Quantidade" :size="size1">{{
                        itemRequisicao.quantidade
                    }}</detalhe>
                    <detalhe titulo="Sub Total" :size="size1">{{
                        itemRequisicao.subTotal | currency
                    }}</detalhe>
                    <detalhe titulo="Desconto" :size="size1">{{
                        itemRequisicao.desconto | currency
                    }}</detalhe>
                    <detalhe titulo="Valor Total" :size="size1">{{
                        itemRequisicao.valorTotal | currency
                    }}</detalhe>
                </b-col>
            </b-row>
            <b-row v-if="itemRequisicao.desconto">
                <b-col sm="12">
                    <b-form-checkbox
                        v-model="cancelarDesconto"
                        :value="true"
                        :unchecked-value="false"
                    >
                        Cancelar desconto
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row v-if="!cancelarDesconto">
                <b-col sm="12">
                    <b-form-group
                        :state="$v.desconto.$error ? false : null"
                        invalid-feedback="O valor é obrigatório"
                    >
                        <label class="required">Desconto</label>
                        <money
                            ref="desconto"
                            v-model="desconto"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.desconto.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input.native="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSalvar()"
                >
                    Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        itemRequisicao: {
            type: Object
        }
    },

    data() {
        return {
            desconto: 0,
            justificativa: null,
            cancelarDesconto: false,
            mostrarModal: false,
            erros: [],
            size1: '130',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    validations: {
        justificativa: {
            required
        },
        desconto: {
            valorOk() {
                if (this.cancelarDesconto) {
                    return true
                }
                return this.desconto > 0
            }
        }
    },

    methods: {
        fecharModal() {
            this.desconto = 0
            this.justificativa = null
            this.cancelarDesconto = false
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
            if (this.itemRequisicao.desconto > 0) {
                this.desconto = this.itemRequisicao.desconto
                this.justificativa = this.itemRequisicao.justificativa
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Desconto no item da requisição',
                html: `Confirma a atualização do desconto no item ${this.itemRequisicao.descricao} da requisição?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.atualizarDesconto()
                }
            })
        },

        atualizarDesconto() {
            let itemDto = {
                idItemRequisicao: this.itemRequisicao.idItemRequisicao,
                desconto: this.desconto,
                justificativa: this.justificativa,
                cancelarDesconto: this.cancelarDesconto
            }
            this.$emit('atualizarDescontoItem', itemDto)
            this.fecharModal()
        }
    }
}
</script>
